(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ja-home-grid"] && !Shopify.designMode) return;
  try {
    
  /* ja-home-grid: plays each band's video only when the band is on screen and the video is the one shown at the
     current width (desktop and mobile can use different files); nothing is downloaded for the hidden one, including
     its poster (data-poster, see snippets/ja-home-media.liquid). Respects prefers-reduced-motion (poster only).
     Works after theme-editor re-renders (connectedCallback). */
  if (!customElements.get('ja-home-grid')) {
    class JaHomeGrid extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.sync = this.sync.bind(this);
        this.mq.addEventListener('change', this.sync);
        this.reduce.addEventListener('change', this.sync);
        this.inView = false;
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((e) => { this.inView = e.isIntersecting; });
            this.sync();
          }, { rootMargin: '300px 0px' });
          this.io.observe(this);
        } else {
          this.inView = true;
          this.sync();
        }
      }
      disconnectedCallback() {
        if (this.mq) this.mq.removeEventListener('change', this.sync);
        if (this.reduce) this.reduce.removeEventListener('change', this.sync);
        if (this.io) this.io.disconnect();
      }
      sync() {
        this.querySelectorAll('video[data-ja-video]').forEach((v) => {
          const shown = v.getClientRects().length > 0;
          if (shown && this.inView) {
            if (v.dataset.poster) {
              v.poster = v.dataset.poster;
              v.removeAttribute('data-poster');
            }
            if (!this.reduce.matches) {
              if (!v.dataset.jaLoaded) {
                v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; });
                v.dataset.jaLoaded = '1';
                v.load();
              }
              const p = v.play();
              if (p && p.catch) p.catch(() => {});
              return;
            }
          }
          if (!v.paused) v.pause();
        });
      }
    }
    customElements.define('ja-home-grid', JaHomeGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
